import { OsttraApplication } from "../components/app-gallery/Applications";
import LoginQueryParams from "../types/LoginQueryParams";

export type SortOrder = "asc" | "desc";

export type ViewType = "card" | "table";

const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const checkForValidEmail = (email: string) => {
  return emailRegex.test(email);
};

export const redirectToLogin = (loginRedirectUrl: string) => {
  window.location.assign(loginRedirectUrl);
};

export const redirectToForgetPassword = (email: string) => {
  const encodedEmail = encodeURIComponent(email);
  window.location.assign(`/api/auth/v1/password-reset?email=${encodedEmail}`);
};

export const getCurrentYear = new Date().getFullYear();

export function normalizeString(str: string) {
  return (str ?? "").toString().trim().toLowerCase();
}

export function searchApps(apps: OsttraApplication[], searchText: string) {
  const query = normalizeString(searchText);
  if (!query) return apps.slice();
  return apps.filter((app) => normalizeString(app.appName).includes(query));
}

export function sortApps(apps: OsttraApplication[], sortOrder: SortOrder = "asc") {
  return apps.slice().sort((a, b) => {
    return sortOrder === "asc"
      ? (a.appName ?? "").localeCompare(b.appName ?? "")
      : (b.appName ?? "").localeCompare(a.appName ?? "");
  });
}

export function getFilteredApps(apps: OsttraApplication[], searchText: string, sortOrder: SortOrder) {
  const searchedApps = searchApps(apps, searchText);
  return sortApps(searchedApps, sortOrder);
}

export const getUserLoginUrl = (
  baseUrl: string,
  loginId: string,
  loginParams: LoginQueryParams,
  loginIdParamName: string = "login_hint"
) => {
  const queryParams = new URLSearchParams();

  queryParams.set(loginIdParamName, loginId || "");

  const {
    client_id = "",
    scope = "",
    nonce = "",
    state = "",
    redirect_uri = "",
    response_type = "",
    authRedirectUri = "",
  } = loginParams;

  queryParams.set("client_id", client_id);
  queryParams.set("scope", scope);
  queryParams.set("nonce", nonce);
  queryParams.set("state", state);
  queryParams.set("redirect_uri", redirect_uri);
  queryParams.set("response_type", response_type);
  queryParams.set("auth_redirect_uri", authRedirectUri);

  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return String(err);
}
